"use strict";
const FREIGHT_INDEX_INCREASE_20250701 = 1.046; // price index adjustment 1/07/2025 with 4.6 %
// price index adjustment 1/07/2025 with 4.6 %
const transportPriceListIndexAdjusted20250701 = [
    {
        type: 'EPAL',
        zipStart: 10,
        zipEnd: 19,
        price: 349 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EPAL',
        zipStart: 20,
        zipEnd: 27,
        price: 575 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EPAL',
        zipStart: 28,
        zipEnd: 39,
        price: 575 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EPAL',
        zipStart: 40,
        zipEnd: 51,
        price: 575 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EPAL',
        zipStart: 52,
        zipEnd: 57,
        price: 503 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EPAL',
        zipStart: 58,
        zipEnd: 61,
        price: 477 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EPAL',
        zipStart: 62,
        zipEnd: 62,
        price: 780 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EPAL',
        zipStart: 63,
        zipEnd: 76,
        price: 494 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EPAL',
        zipStart: 77,
        zipEnd: 82,
        price: 539 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EPAL',
        zipStart: 83,
        zipEnd: 88,
        price: 762 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EPAL',
        zipStart: 89,
        zipEnd: 93,
        price: 945 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EPAL',
        zipStart: 94,
        zipEnd: 98,
        price: 1309 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EUR6',
        zipStart: 10,
        zipEnd: 19,
        price: 229 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EUR6',
        zipStart: 20,
        zipEnd: 27,
        price: 459 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EUR6',
        zipStart: 28,
        zipEnd: 39,
        price: 459 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EUR6',
        zipStart: 40,
        zipEnd: 51,
        price: 459 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EUR6',
        zipStart: 52,
        zipEnd: 57,
        price: 402 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EUR6',
        zipStart: 58,
        zipEnd: 61,
        price: 382 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EUR6',
        zipStart: 62,
        zipEnd: 62,
        price: 624 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EUR6',
        zipStart: 63,
        zipEnd: 76,
        price: 395 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EUR6',
        zipStart: 77,
        zipEnd: 82,
        price: 431 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EUR6',
        zipStart: 83,
        zipEnd: 88,
        price: 609 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EUR6',
        zipStart: 89,
        zipEnd: 93,
        price: 756 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'EUR6',
        zipStart: 94,
        zipEnd: 98,
        price: 1047 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 10,
        zipEnd: 19,
        price: 229 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 20,
        zipEnd: 27,
        price: 373 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 28,
        zipEnd: 39,
        price: 373 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 40,
        zipEnd: 51,
        price: 373 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 52,
        zipEnd: 57,
        price: 327 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 58,
        zipEnd: 61,
        price: 310 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 62,
        zipEnd: 62,
        price: 506 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 63,
        zipEnd: 76,
        price: 321 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 77,
        zipEnd: 82,
        price: 351 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 83,
        zipEnd: 88,
        price: 495 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 89,
        zipEnd: 93,
        price: 615 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 94,
        zipEnd: 98,
        price: 851 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'OTHER',
        zipStart: 10,
        zipEnd: 19,
        price: 115 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'OTHER',
        zipStart: 20,
        zipEnd: 27,
        price: 862 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'OTHER',
        zipStart: 28,
        zipEnd: 39,
        price: 862 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'OTHER',
        zipStart: 40,
        zipEnd: 51,
        price: 862 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'OTHER',
        zipStart: 52,
        zipEnd: 57,
        price: 755 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'OTHER',
        zipStart: 58,
        zipEnd: 61,
        price: 716 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'OTHER',
        zipStart: 62,
        zipEnd: 62,
        price: 1169 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'OTHER',
        zipStart: 63,
        zipEnd: 76,
        price: 741 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'OTHER',
        zipStart: 77,
        zipEnd: 82,
        price: 809 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'OTHER',
        zipStart: 83,
        zipEnd: 88,
        price: 1142 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'OTHER',
        zipStart: 89,
        zipEnd: 93,
        price: 1418 * FREIGHT_INDEX_INCREASE_20250701,
    },
    {
        type: 'OTHER',
        zipStart: 94,
        zipEnd: 98,
        price: 1964 * FREIGHT_INDEX_INCREASE_20250701,
    },
];
const transportPriceList = [
    {
        type: 'EPAL',
        zipStart: 10,
        zipEnd: 19,
        price: 349,
    },
    {
        type: 'EPAL',
        zipStart: 20,
        zipEnd: 27,
        price: 575,
    },
    {
        type: 'EPAL',
        zipStart: 28,
        zipEnd: 39,
        price: 575,
    },
    {
        type: 'EPAL',
        zipStart: 40,
        zipEnd: 51,
        price: 575,
    },
    {
        type: 'EPAL',
        zipStart: 52,
        zipEnd: 57,
        price: 503,
    },
    {
        type: 'EPAL',
        zipStart: 58,
        zipEnd: 61,
        price: 477,
    },
    {
        type: 'EPAL',
        zipStart: 62,
        zipEnd: 62,
        price: 780,
    },
    {
        type: 'EPAL',
        zipStart: 63,
        zipEnd: 76,
        price: 494,
    },
    {
        type: 'EPAL',
        zipStart: 77,
        zipEnd: 82,
        price: 539,
    },
    {
        type: 'EPAL',
        zipStart: 83,
        zipEnd: 88,
        price: 762,
    },
    {
        type: 'EPAL',
        zipStart: 89,
        zipEnd: 93,
        price: 945,
    },
    {
        type: 'EPAL',
        zipStart: 94,
        zipEnd: 98,
        price: 1309,
    },
    {
        type: 'EUR6',
        zipStart: 10,
        zipEnd: 19,
        price: 229,
    },
    {
        type: 'EUR6',
        zipStart: 20,
        zipEnd: 27,
        price: 459,
    },
    {
        type: 'EUR6',
        zipStart: 28,
        zipEnd: 39,
        price: 459,
    },
    {
        type: 'EUR6',
        zipStart: 40,
        zipEnd: 51,
        price: 459,
    },
    {
        type: 'EUR6',
        zipStart: 52,
        zipEnd: 57,
        price: 402,
    },
    {
        type: 'EUR6',
        zipStart: 58,
        zipEnd: 61,
        price: 382,
    },
    {
        type: 'EUR6',
        zipStart: 62,
        zipEnd: 62,
        price: 624,
    },
    {
        type: 'EUR6',
        zipStart: 63,
        zipEnd: 76,
        price: 395,
    },
    {
        type: 'EUR6',
        zipStart: 77,
        zipEnd: 82,
        price: 431,
    },
    {
        type: 'EUR6',
        zipStart: 83,
        zipEnd: 88,
        price: 609,
    },
    {
        type: 'EUR6',
        zipStart: 89,
        zipEnd: 93,
        price: 756,
    },
    {
        type: 'EUR6',
        zipStart: 94,
        zipEnd: 98,
        price: 1047,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 10,
        zipEnd: 19,
        price: 229,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 20,
        zipEnd: 27,
        price: 373,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 28,
        zipEnd: 39,
        price: 373,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 40,
        zipEnd: 51,
        price: 373,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 52,
        zipEnd: 57,
        price: 327,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 58,
        zipEnd: 61,
        price: 310,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 62,
        zipEnd: 62,
        price: 506,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 63,
        zipEnd: 76,
        price: 321,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 77,
        zipEnd: 82,
        price: 351,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 83,
        zipEnd: 88,
        price: 495,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 89,
        zipEnd: 93,
        price: 615,
    },
    {
        type: 'QUARTER_PALLET',
        zipStart: 94,
        zipEnd: 98,
        price: 851,
    },
    {
        type: 'OTHER',
        zipStart: 10,
        zipEnd: 19,
        price: 115,
    },
    {
        type: 'OTHER',
        zipStart: 20,
        zipEnd: 27,
        price: 862,
    },
    {
        type: 'OTHER',
        zipStart: 28,
        zipEnd: 39,
        price: 862,
    },
    {
        type: 'OTHER',
        zipStart: 40,
        zipEnd: 51,
        price: 862,
    },
    {
        type: 'OTHER',
        zipStart: 52,
        zipEnd: 57,
        price: 755,
    },
    {
        type: 'OTHER',
        zipStart: 58,
        zipEnd: 61,
        price: 716,
    },
    {
        type: 'OTHER',
        zipStart: 62,
        zipEnd: 62,
        price: 1169,
    },
    {
        type: 'OTHER',
        zipStart: 63,
        zipEnd: 76,
        price: 741,
    },
    {
        type: 'OTHER',
        zipStart: 77,
        zipEnd: 82,
        price: 809,
    },
    {
        type: 'OTHER',
        zipStart: 83,
        zipEnd: 88,
        price: 1142,
    },
    {
        type: 'OTHER',
        zipStart: 89,
        zipEnd: 93,
        price: 1418,
    },
    {
        type: 'OTHER',
        zipStart: 94,
        zipEnd: 98,
        price: 1964,
    },
];
module.exports = {
    transportPriceListIndexAdjusted20250701,
    transportPriceList,
    FREIGHT_INDEX_INCREASE_20250701,
};
